import { WifiOff } from 'lucide-react';
import { useOfflineStatus } from '../../hooks/useOfflineStatus';
import { useTranslation } from '../../i18n';

export function OfflineBanner() {
  const { isOnline } = useOfflineStatus();
  const { t: strings } = useTranslation();

  if (isOnline) return null;

  return (
    <div className="sticky top-16 z-30 bg-amber-50 dark:bg-amber-950/60 border-b border-amber-200 dark:border-amber-800 px-4 py-2 text-sm font-medium text-amber-700 dark:text-amber-400">
      <div className="mx-auto max-w-7xl flex items-center justify-center gap-2">
        <WifiOff size={16} className="shrink-0" />
        <span>{strings.common.offlineBanner}</span>
      </div>
    </div>
  );
}
